module.exports = __webpack_public_path__ + "35209044e60ef390700fe11c385bdc4f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/letters/3.png
// module id = 2945
// module chunks = 0